import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'next-themes';
import { initWebStorage } from '@bettercampus/global/runtime';
import App from './App';
import { Toaster } from '@/components/ui/sonner';
import './styles.css';

// Initialize storage adapter before React renders — pages depend on it immediately
initWebStorage();

const rootElement = document.getElementById('root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
          <App />
          <Toaster position="top-center" richColors />
        </ThemeProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}
